import React from "react";

import { LDProvider } from "launchdarkly-react-client-sdk";

import { LAUNCH_DARKLY_DEFAULT_FLAGS, DEFAULT_REACT_OPTIONS } from "./constants";

const defaultObj = {};

export const FeatureFlagProvider = ({
  clientSideID = "",
  children,
  configurations,
  isReadyForInit,
}) => {
  const config = isReadyForInit ? configurations : defaultObj;
  return (
    <LDProvider
      clientSideID={clientSideID}
      flags={LAUNCH_DARKLY_DEFAULT_FLAGS}
      deferInitialization
      reactOptions={DEFAULT_REACT_OPTIONS}
      {...config}
    >
      {children}
    </LDProvider>
  );
};
